"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListNestedExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/list/examples/nested.ts';
var data = [
    {
        label: 'Header 1',
        children: [
            'List item 1',
            'List item 2',
            'List item 3'
        ]
    },
    {
        label: 'Header 2',
        children: [
            'List item 4',
            'List item 5',
            'List item 6'
        ]
    },
    {
        label: 'Header 3',
        children: [
            'List item 7',
            'List item 8',
            'List item 9'
        ]
    }
];
var ListNestedExample = /** @class */ (function () {
    function ListNestedExample() {
    }
    ListNestedExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.List, data.map(function (item) { return (0, mithril_1.default)('', [
                (0, mithril_1.default)('h4', {
                    style: {
                        margin: 0,
                        padding: '20px 0 10px 10px'
                    }
                }, item.label),
                (0, mithril_1.default)(_1.List, item.children.map(function (nestedItem) { return (0, mithril_1.default)(_1.ListItem, { label: nestedItem }); }))
            ]); }))
        ]);
    };
    return ListNestedExample;
}());
exports.ListNestedExample = ListNestedExample;
